import './GfActionMenuIcon.scss';

import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { IconProps, SemanticShorthandItem } from 'semantic-ui-react';

type GfActionMenuIconProps = PropsWithChildren<{
  className?: string;
  icon?: SemanticShorthandItem<IconProps>;
}>;

export default function GfActionMenuIcon({ children, className, icon }: GfActionMenuIconProps) {
  return (
    <span className={classNames(className, 'gf-action-menu-icon')}>
      <i className={classNames('icon', icon as string)}>{children}</i>
    </span>
  );
}
